module.exports = __webpack_public_path__ + "static/Erp-4a2a3d38728f24787ef823c4b38a978e.png";